















































































import { Account, Team } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'

@Component
export default class UpsertTeamModal extends Vue {
  @Prop({ required: false }) team: Team

  private teamSave: Team = {
    id: 0,
    name: '',
    responsibleId: '',
    createdOn: '',
    updatedOn: ''
  }

  private responsibleOptions: Account[] = []

  @Watch('team', { deep: true })
  onTeamChanged() {
    this.updateTeam()
  }

  get newTeam(): boolean {
    return this.team == null || !this.team.id
  }

  private updateTeam() {
    if (this.team && this.team.id) {
      Vue.set(this.teamSave, 'id', this.team.id)
      Vue.set(this.teamSave, 'name', this.team.name)
      Vue.set(this.teamSave, 'responsibleId', this.team.responsibleId)
      this.preloadResponsible(this.team.responsibleId)
    } else {
      this.clearForm()
    }
  }

  private async preloadResponsible(accountId: string) {
    if (!accountId) return
    try {
      const result = await ApiClient.searchAccounts(accountId, 1, 0)
      if (result.items.length > 0) {
        this.responsibleOptions = [result.items[0]]
      }
    } catch (e) {
      console.error('Error preloading responsible', e)
    }
  }

  searchAccounts(search: string, loading: (value: boolean) => void) {
    if (!search || search.length < 2) {
      this.responsibleOptions = []
      return
    }
    loading(true)
    ApiClient.searchAccounts(search, 20, 0)
      .then(result => {
        this.responsibleOptions = result.items
      })
      .catch(error => {
        console.error('Error searching accounts:', error)
      })
      .finally(() => loading(false))
  }

  private formOk(): boolean {
    return !!this.teamSave.name && !!this.teamSave.responsibleId
  }

  hideModal() {
    this.$bvModal.hide('UpsertTeamModal')
  }

  private saveForm(): void {
    if (!this.formOk()) {
      alert('Form not valid!')
      return
    }
    const promise = this.newTeam
      ? ApiClient.createTeam(this.teamSave)
      : ApiClient.updateTeam(this.teamSave.id, this.teamSave)

    promise
      .then((teamSaved: Team) => {
        this.$emit('teamSaved', teamSaved)
        this.hideModal()
        this.clearForm()
      })
      .catch((ex: Error) => alert(`Error: ${ex.message}`))
  }

  private clearForm() {
    Vue.set(this.teamSave, 'id', 0)
    Vue.set(this.teamSave, 'name', '')
    Vue.set(this.teamSave, 'responsibleId', '')
    this.responsibleOptions = []
  }
}
